import $ from 'jquery';
import 'foundation-sites';
import 'what-input';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

var run = 0;

$(document).foundation();

$(document).ready(function() {
  // === Animations mit IntersectionObserver ===
  let options = {
    root: null,
    rootMargin: "0px 0px -50px 0px",
    threshold: 0.33,
  };

  let observer = new IntersectionObserver((entries, self) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $(entry.target)
          .removeClass("invisible")
          .addClass("animated visible");
        self.unobserve(entry.target);
      }
    });
  }, options);

  document.querySelectorAll(".anim").forEach((obj) => {
    observer.observe(obj);
  });

  // === Menü Button Animation ===
  $("#openMenu").on("click", function () {
    $(this).toggleClass("change");
  });

  // Offcanvas schließen auch jenseits von "X"
  $(".off-canvas").on("closed.zf.offcanvas", function () {
    $("#openMenu").removeClass("change");
  });


    // 🚀 GLightbox Setup
    const lightbox = GLightbox({
        selector: "a[data-rel^='lightcase']", // nimmt deine alten Lightcase-Links
        touchNavigation: true,
        loop: true,
        zoomable: true,
        openEffect: "zoom",
        closeEffect: "fade"
    });
});
